import { observer } from 'mobx-react-lite'
import { type Member } from '@/features/iam/members/Member'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { RequestedProvider } from '@/features/jobs/details/components/CollaboratorsCard/RequestedProvider'

export interface RequestedProviderContainerProps {
  vm: JobDetailsViewModel
  provider: Member
}

export const RequestedProviderContainer = observer(
  function RequestedProviderContainer({
    vm,
    provider,
  }: RequestedProviderContainerProps) {
    return (
      <RequestedProvider
        displayName={provider.displayName}
        email={provider.email}
        phone={provider.phone}
        isOnline={provider.user.online}
        avatar={{
          avatar: provider.avatar,
          avatarFallback: provider.avatarFallback,
          displayName: provider.displayName,
        }}
        canViewActionsMenu={
          vm.collaboratorsVm.canViewRequestedProviderActionsMenu
        }
        onRemove={vm.collaboratorsVm.removeRequestedChampionProviderAsAdmin}
      />
    )
  },
)
